function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.24169 7.744C4.56321 7.41941 5.08445 7.41718 5.40597 7.74623L12.5826 15.0723C12.9041 15.4002 12.903 15.93 12.5804 16.2557C12.4202 16.4175 12.2095 16.5 11.9999 16.5C11.7881 16.5 11.5774 16.4175 11.4172 16.2535L4.24059 8.92745C3.91907 8.59952 3.92017 8.0697 4.24169 7.744ZM18.5929 7.74634C18.9145 7.41729 19.4357 7.41952 19.7572 7.74411C20.0798 8.06981 20.0809 8.59963 19.7605 8.92756L14.9948 13.793C14.8345 13.957 14.6228 14.0395 14.4121 14.0395C14.2025 14.0395 13.9918 13.957 13.8316 13.7952C13.509 13.4695 13.5079 12.9397 13.8283 12.6118L18.5929 7.74634Z",
  fill: "currentColor"
});

var SvgDownChevron = function SvgDownChevron(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownChevron, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/down_chevron.342b8390.svg";
export { ForwardRef as ReactComponent };